// Shared by the API and phone. The timeout is a missing-result boundary,
// never an estimate of measurement duration or a wait after a result.
export const MEASUREMENT_TIMEOUT_MS = 120_000;
export const measurementKind = type => type === "HRTSTART" ? "heartPressure" : type === "BODYTEMP2" ? "temperature" : null;

/** @param {{type:string, status:string, queuedAt:string, sentAt:string|null}|undefined} command
 * @param {Array<{kind:string,receivedAt:string,quality:string}>} reports */
export function measurementReport(command, reports, now = Infinity, kind = measurementKind(command?.type)) {
  if (!command || command.status === "failed" || !command.sentAt) return undefined;
  const start = Date.parse(command.sentAt);
  const deadline = Date.parse(command.queuedAt) + MEASUREMENT_TIMEOUT_MS;
  // No protocol request id exists: this is the first matching report received
  // after sending, not proof of causation. Older/late/future reports cannot finish it.
  return reports.filter(r => r.kind === kind && Date.parse(r.receivedAt) >= start
    && Date.parse(r.receivedAt) <= Math.min(deadline, now))
    .sort((a, b) => Date.parse(a.receivedAt) - Date.parse(b.receivedAt))[0];
}

/** @param {{type:string, status:string, queuedAt:string, sentAt:string|null}} command
 * @param {Array<{kind:string,receivedAt:string,quality:string}>} reports */
export function measurementRemainingMs(command, reports, now = Date.now()) {
  if (!measurementKind(command.type) || command.status === "failed" || measurementReport(command, reports, now)) return 0;
  return Math.max(0, Date.parse(command.queuedAt) + MEASUREMENT_TIMEOUT_MS - now);
}

/** @template {{type:string, status:string, queuedAt:string, sentAt:string|null}} T
 * @param {T[]} commands
 * @param {Array<{kind:string,receivedAt:string,quality:string}>} reports */
export function activeMeasurement(commands, reports, now = Date.now()) {
  return commands.filter(c => measurementRemainingMs(c, reports, now) > 0)
    .sort((a, b) => Date.parse(b.queuedAt) - Date.parse(a.queuedAt))[0];
}
